module.exports = __webpack_public_path__ + "img/互动交流.19ac7ec5.png";